import { useClient, useDictionary } from "@adamlip/okeoke.client"
import SelectLocationModal from "components/SelectLocationModal"
import useBasket from "hooks/useBasket"
import { useState, useContext, useEffect } from "react"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function LocationSelector() {
  const { selectedLocationUUID, locations } = useClient()
  const { appParams } = useContext(AppParamsContext)
  const { getValue } = useDictionary()
  const { savedTable } = useBasket()
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedStyle, setSelectedStyle] = useState("")
  const extendedPrepTime = null
  const location = locations?.[selectedLocationUUID]

  const openLocationModal = () => {
    if (appParams?.order?.locationSelectorReadOnly) return null
    setModalOpen(true)
  }

  useEffect(() => {
    switch (appParams?.order?.locationSelectorType) {
      case "2":
        setSelectedStyle("border-2 border-[var(--main-border-color)]")
        break
      default:
        setSelectedStyle("shadow-sm bg-[var(--main-secondary-bg-color)]")
    }
  }, [appParams])

  return (
    <>
      <SelectLocationModal
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        isDismissable={true}
      />
      <div
        className={`location-selector-root hidden-content appear my-2 md:max-w-[500px] md:ml-auto md:mr-1 ${
          extendedPrepTime?.prepTime != null ? "extended" : ""
        }`}
        onClick={openLocationModal}
      >
        <div
          className={`location-selector-inner w-full mx-6 my-1 ${selectedStyle}`}
        >
          {extendedPrepTime?.prepTime != null && (
            <div className="extended-message">
              {getValue("app_v2_location_extendedPrepTime")}
            </div>
          )}
          {/* <div className="location-selector-icon">
            <LoadSvg name="setLocation" />
          </div> */}
          <div className="location-name grow truncate">
            {location?.name == null && getValue("app_v2_location_select")}
            {location?.name != null && (
              <>
                <>{`${location?.name}${
                  savedTable?.name != null ? " (" + savedTable?.name + ")" : ""
                } - `}</>
                {location?.openState?.forceClosedUntil != null && (
                  <span className="open-state">
                    {getValue("app_v2_location_pause")}
                  </span>
                )}
                {location?.openState?.forceClosedUntil == null &&
                  (location?.openState?.open ? (
                    <span className="open-state">
                      {getValue("app_v2_location_open")}
                    </span>
                  ) : (
                    <span className="open-state">
                      {getValue("app_v2_location_closed")}
                    </span>
                  ))}
              </>
            )}
          </div>
          {/* <div
            className={`location-selector-icon chevron-icon flex-center ${
              modalOpen ? "modal-open" : "modal-closed"
            }`}
          >
            {(appParams?.order?.locationSelectorReadOnly == null ||
              appParams?.order?.locationSelectorReadOnly === false) && (
              <LoadSvg name="chevron" />
            )}
          </div> */}
        </div>
      </div>
    </>
  )
}
